import { Notification } from '../types/notification';

export const sampleNotifications: Notification[] = [
  {
    id: 'n1',
    title: 'Due Diligence Deadline',
    message: 'Technical due diligence report is due in 24 hours',
    timestamp: new Date(Date.now() - 1800000).toISOString(), // 30 minutes ago
    read: false,
    type: 'warning',
    dealId: 'deal-1'
  },
  {
    id: 'n2',
    title: 'New Document Uploaded',
    message: 'Financial statements Q4 2023 added to data room',
    timestamp: new Date(Date.now() - 3600000).toISOString(), // 1 hour ago
    read: false,
    type: 'info',
    dealId: 'deal-2'
  },
  {
    id: 'n3',
    title: 'Meeting Reminder',
    message: 'Integration planning meeting starts in 15 minutes',
    timestamp: new Date(Date.now() - 7200000).toISOString(), // 2 hours ago
    read: false,
    type: 'info',
    dealId: 'deal-1'
  },
  {
    id: 'n4',
    title: 'Risk Alert',
    message: 'High-priority regulatory risk identified in Tech Corp acquisition',
    timestamp: new Date(Date.now() - 86400000).toISOString(), // 1 day ago
    read: true,
    type: 'error',
    dealId: 'deal-1'
  },
  {
    id: 'n5',
    title: 'Synergy Target Achieved',
    message: 'Cost reduction target of $2M achieved in IT consolidation',
    timestamp: new Date(Date.now() - 172800000).toISOString(), // 2 days ago
    read: true,
    type: 'success',
    dealId: 'deal-1'
  }
];